import useAbTestInit from '../../hooks/use-ab-test-init';
import type { ABTestConfigProps } from '../ab-test-global-provider';

const NavDemoLink = ({ shortCode }: ABTestConfigProps) =>
  useAbTestInit({
    isAboveTheFold: true,
    branchesToRender: ['T_A', 'T_B'],
    testName: 'LucidSuiteNavWatchADemo2',
    willTriggerFire: shortCode === 'en',
  });

export default NavDemoLink;
